module.exports = __webpack_public_path__ + "img/xinzhuang-3.bc898ab4.jpg";